module.exports = __webpack_public_path__ + "static/progetto_valtellinapalace7-1f3471de96de59048e83240d2ca8f629.jpg";